import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { AmenityCard } from "../components/AmenityCard";
import { confirmedAmenities, enabledOptionalAmenities } from "../config/amenities";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { SmartImage } from "../components/SmartImage";
import { images } from "../config/images";
import { ContactCTA } from "../components/home/ContactCTA";

export default function Amenities() {
  const { t } = useLanguage();
  return (
    <main data-testid="amenities-page">
      <SEOHead title={t.meta.amenities.title} description={t.meta.amenities.description} />
      <PageHeader eyebrow={t.amenitiesPage.eyebrow} title={t.amenitiesPage.title} text={t.amenitiesPage.text} crumb={t.nav.amenities} testId="amenities-header" />

      <section className="container-x">
        <Reveal><h2 className="h3">{t.amenitiesPage.confirmedTitle}</h2></Reveal>
        <Stagger className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {confirmedAmenities.map((a) => <StaggerItem key={a.id}><AmenityCard amenity={a} /></StaggerItem>)}
        </Stagger>
      </section>

      <section className="container-x section">
        <div className="grid gap-6 md:grid-cols-2">
          <Reveal className="card overflow-hidden">
            <SmartImage src={images.kitchen} alt={t.amenitiesPage.kitchenTitle} isPlaceholder className="aspect-[16/10]" />
            <div className="p-7"><h3 className="h3">{t.amenitiesPage.kitchenTitle}</h3><p className="mt-2 text-charcoal-500" data-testid="amenities-kitchen-text">{t.amenitiesPage.kitchenText}</p></div>
          </Reveal>
          <Reveal className="card overflow-hidden" delay={0.1}>
            <SmartImage src={images.bathroom} alt={t.amenitiesPage.bathTitle} isPlaceholder className="aspect-[16/10]" />
            <div className="p-7"><h3 className="h3">{t.amenitiesPage.bathTitle}</h3><p className="mt-2 text-charcoal-500" data-testid="amenities-bath-text">{t.amenitiesPage.bathText}</p></div>
          </Reveal>
        </div>
      </section>

      <section className="container-x section !pt-0">
        <Reveal><h2 className="h3">{t.amenitiesPage.optionalTitle}</h2></Reveal>
        {enabledOptionalAmenities.length === 0 ? (
          <Reveal><p className="mt-6 max-w-2xl rounded-3xl bg-sand-50 p-6 text-charcoal-700" data-testid="amenities-optional-empty">{t.amenitiesPage.optionalEmpty}</p></Reveal>
        ) : (
          <Stagger className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {enabledOptionalAmenities.map((a) => <StaggerItem key={a.id}><AmenityCard amenity={a} /></StaggerItem>)}
          </Stagger>
        )}
      </section>

      <ContactCTA />
    </main>
  );
}
